import { CircularProgress, Typography } from '@mui/material'
import { useAsyncEffect } from '@xylabs/sdk-react'
import { useContext, useState } from 'react'

import { EditDialog } from '../../../Components'
import { AuthenticationContext, EthersContext, useGeotoken, useGeotokenSettings } from '../../../Contexts'
import { Property } from '../../Property'

const SponsorProperty: React.FC = () => {
  const { localAddress, showConnectWalletDialog } = useContext(EthersContext)
  const { auth } = useContext(AuthenticationContext)
  const geotoken = useGeotoken()
  const settings = useGeotokenSettings()

  const [isOwner, setIsOwner] = useState<boolean | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const owner = await geotoken?.getOwner()
      const data = owner && localAddress && owner?.toHex() === localAddress?.toHex()
      if (!isMounted()) return
      setIsOwner(data)
    },
    [geotoken, localAddress],
  )

  const [editing, setEditing] = useState(false)

  const onSave = async (value: string) => {
    if (settings && auth?.authenticated()) {
      settings.data = { ...settings.data, sponsor: value }
      await settings.save()
      setEditing(false)
    }
  }

  const onEditClick = async () => {
    if (auth?.authenticated()) {
      setEditing(true)
    } else if (auth) {
      if (await auth?.signIn?.()) {
        setEditing(true)
      }
    } else {
      showConnectWalletDialog?.()
    }
  }

  return (
    <Property
      actions={[{ disabled: !isOwner, name: 'Change', onClick: onEditClick }]}
      tip={isOwner ? "Displayed in COIN as the 'Brought to you by...'." : undefined}
      title="Sponsor"
      value={settings?.data?.sponsor ?? (settings ? null : undefined)}
    >
      {settings?.data ? <Typography variant="caption">{settings?.data?.sponsor}</Typography> : <CircularProgress size={24} />}
      <EditDialog
        fieldName="Sponser"
        fieldValue={settings?.data?.sponsor}
        maxLength={18}
        onCancel={() => setEditing(false)}
        onSave={onSave}
        open={editing}
      />
    </Property>
  )
}

export default SponsorProperty
